import { alertActions } from "./";
import { history } from "../_helpers";
import { pushNotificationService } from "../_services/pushNotification";
import { TwoPlusService } from "../_services/towplus.service";
import { professionalConstants } from "../_constants";

export const twoPlusAction = {
  get2lusArophiCount,
  get2lusNewArophiPoliceStationCount,
  get2lusNewArophiCount,
  get2PlusNewArophiList,
  get2plusNewArophiListPoliceStation,
  get2lusArophiListCount,
  get2lusArophiListPoliceStationCount,
  getCriminalsByCityId,
  getHistorySheeterCount,
  getHistorySheeterCountPS,
  getHistorySheeterList,
  getHistorySheeterListPS,
  getCriminalHistoryDetails,
  get2lusArophiByUserIdCount,
  get2plusNewArophiByidList,
  get2lusArophiListByIdCount,
  getHistorySheeterByIdCount,
  getHistorySheeterByIdList,
  getPlus2ArophiListByRole,
  get2lusArophiListCountByRole,
  getHistorySheeterListByRole,
  get2lusNewArophiCountByRole,
  get2lusArophiCountByRole,
  getHistorySheeterCountByRole,
  get2lusNewListArophiCount,
  get2lusNewListArophiCountByRole,
  get2PlusNewAropiPostBharaliList,
  get2PlusNewAropiPostBharaliCount,
  get2lusNewListPostBharaliCount,
  get2lusArophiPostBharaliList,
  get2PlusNewAropiPostBharaliListByRole,
  get2PlusNewAropiPostBharaliCountByRole,
  get2lusNewListPostBharaliCountByRole,
  get2lusArophiPostBharaliListByRole,
  get2plusNewArophiPreventiveActionList,
  get2plusNewArophiPreventiveActionPoliceStationList,
};

function get2lusArophiCount(startDate, endDate, cityId) {
  return TwoPlusService.get2lusArophiCount(startDate, endDate, cityId);
}
function get2lusNewArophiPoliceStationCount(startDate, endDate, id) {
  return TwoPlusService.get2lusNewArophiPoliceStationCount(
    startDate,
    endDate,
    id
  );
}

function get2lusNewArophiCount(startDate, endDate, cityId) {
  return TwoPlusService.get2lusNewArophiCount(startDate, endDate, cityId);
}

function get2PlusNewArophiList(startDate, endDate, cityId) {
  return TwoPlusService.get2PlusNewArophiList(startDate, endDate, cityId);
}
function get2plusNewArophiListPoliceStation(startDate, endDate, id) {
  return TwoPlusService.get2plusNewArophiListPoliceStation(
    startDate,
    endDate,
    id
  );
}
function get2lusArophiListCount(startDate, endDate, cityId) {
  return TwoPlusService.get2lusArophiListCount(startDate, endDate, cityId);
}
function get2lusArophiListPoliceStationCount(startDate, endDate, id) {
  return TwoPlusService.get2lusArophiListPoliceStationCount(
    startDate,
    endDate,
    id
  );
}

function getCriminalsByCityId(
  startDate,
  endDate,
  cityId,
  districtName,
  date_order
) {
  return TwoPlusService.getCriminalsByCityId(
    startDate,
    endDate,
    cityId,
    districtName,
    date_order
  );
}

function getHistorySheeterCount(values) {
  return TwoPlusService.getHistorySheeterCount(values);
}

function getHistorySheeterCountPS(values) {
  return TwoPlusService.getHistorySheeterCountPS(values);
}

function getHistorySheeterList(cityId) {
  return TwoPlusService.getHistorySheeterList(cityId);
}

function getHistorySheeterListPS(values) {
  return TwoPlusService.getHistorySheeterListPS(values);
}

function getCriminalHistoryDetails(cityId, districtName) {
  return TwoPlusService.getCriminalHistoryDetails(cityId, districtName);
}

function get2lusArophiByUserIdCount(startDate, endDate, id) {
  return TwoPlusService.get2lusArophiByUserIdCount(startDate, endDate, id);
}
function get2plusNewArophiByidList(data) {
  return TwoPlusService.get2plusNewArophiByidList(data);
}
function get2lusArophiListByIdCount(data) {
  return TwoPlusService.get2lusArophiListByIdCount(data);
}
function getHistorySheeterByIdCount(values) {
  return TwoPlusService.getHistorySheeterByIdCount(values);
}
function getHistorySheeterByIdList(values) {
  return TwoPlusService.getHistorySheeterByIdList(values);
}

function getPlus2ArophiListByRole(values) {
  return TwoPlusService.getPlus2ArophiListByRole(values);
}
function get2lusArophiListCountByRole(values) {
  return TwoPlusService.get2lusArophiListCountByRole(values);
}
function getHistorySheeterListByRole(values) {
  return TwoPlusService.getHistorySheeterListByRole(values);
}

function get2lusNewArophiCountByRole(values) {
  return TwoPlusService.get2lusNewArophiCountByRole(values);
}
function get2lusArophiCountByRole(values) {
  return TwoPlusService.get2lusArophiCountByRole(values);
}
function getHistorySheeterCountByRole(values) {
  return TwoPlusService.getHistorySheeterCountByRole(values);
}
function get2lusNewListArophiCount(startDate, endDate, cityId) {
  return TwoPlusService.get2lusNewListArophiCount(startDate, endDate, cityId);
}
function get2lusNewListArophiCountByRole(values) {
  return TwoPlusService.get2lusNewListArophiCountByRole(values);
}
function get2PlusNewAropiPostBharaliList(values) {
  return TwoPlusService.get2PlusNewAropiPostBharaliList(values);
}
function get2PlusNewAropiPostBharaliCount(values) {
  return TwoPlusService.get2PlusNewAropiPostBharaliCount(values);
}
function get2lusNewListPostBharaliCount(values) {
  return TwoPlusService.get2lusNewListPostBharaliCount(values);
}
function get2lusArophiPostBharaliList(values) {
  return TwoPlusService.get2lusArophiPostBharaliList(values);
}
function get2PlusNewAropiPostBharaliListByRole(values){
  return TwoPlusService.get2PlusNewAropiPostBharaliListByRole(values);
}
function get2PlusNewAropiPostBharaliCountByRole(values){
  return TwoPlusService.get2PlusNewAropiPostBharaliCountByRole(values);
}
function get2lusNewListPostBharaliCountByRole(values){
return TwoPlusService.get2lusNewListPostBharaliCountByRole(values);
}
function get2lusArophiPostBharaliListByRole(values){
return TwoPlusService.get2lusArophiPostBharaliListByRole(values);
}
function get2plusNewArophiPreventiveActionList(values) {
  return TwoPlusService.get2plusNewArophiPreventiveActionList(values);
}
function get2plusNewArophiPreventiveActionPoliceStationList(values) {
  return TwoPlusService.get2plusNewArophiPreventiveActionPoliceStationList(
    values,
  );
}